import { notification } from 'antd'
import apiClient from 'services/axios'
import { getLoggedInUserInfo } from 'utils'

export const getAllAttendance = async (
  { skip, limit, searchEmp, year, sortBy, sortOrder },
  options = {},
) => {
  const { silent = false } = options
  const empCode = getLoggedInUserInfo()?.empId
  const locationId = getLoggedInUserInfo()?.locationId?.id || getLoggedInUserInfo()?.locationId // only ID
  const userId = getLoggedInUserInfo()?.userId
  // const TimeToken = getLoggedInUserInfo()

  try {
    return await apiClient.get('employee/allAttendance-record', {
      params: {
        userId,
        empCode,
        locationId,
        skip,
        limit,
        searchEmp,
        year,
        sortBy,
        sortOrder,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
export const getEmpAttendance = async (year) => {
  const empCode = getLoggedInUserInfo()?.empId
  try {
    return await apiClient.get(`employee/attendance-record?empCode=${empCode}&year=${year}`)
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const getSingleMonthAttendance = async (userId, month, year, options = {}) => {
  const { silent = false } = options

  try {
    return await apiClient.get(`attendance/getAttendanceByMonth`, {
      params: {
        userId,
        month,
        year,
      },
      suppressErrorNotification: silent,
    })
  } catch (error) {
    if (!silent && error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getEmpAttendanceReport = async ({ skip, limit, userId, month, year }) => {
  try {
    return await apiClient.get(`attendance/attendanceReport/${userId}`, {
      params: {
        skip,
        limit,
        month,
        year,
      },
    })
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getHour = ({ userId, year }) => {
  return apiClient.get(`employee/totalhour/${userId}`, {
    params: {
      userId,
      year,
    },
  })
}
